<ion-content scroll-y="false">
  @if (pdv) {
  <ion-grid class="ion-margin-top">
    <ion-row class="ion-text-center">
      <ion-col size="12">
        <ion-card-title>{{ pdv.name }}</ion-card-title>
        <ion-card-subtitle
          >{{ pdv.address1_line1 }} {{ pdv.address1_line2 }}
          {{ pdv.address1_postalcode }} - {{ pdv.address1_city }}
        </ion-card-subtitle>
      </ion-col>
    </ion-row>
    <ion-row class="ion-text-center">
      <ion-col size="4">
        <ion-button
          (click)="openMap(latitude, longitude, address)"
          (keydown)="openMap(latitude, longitude, address)"
          fill="clear">
          <div>
            <ion-icon name="navigate" size="large"></ion-icon>
            <br />
            <ion-label>Itinéraire</ion-label>
          </div>
        </ion-button>
      </ion-col>
      <ion-col size="4">
        <ion-button
          (click)="openCall()"
          (keydown)="openCall()"
          [disabled]="
            !pdv.telephone1 ||
            !platform.is('mobile') ||
            platform.is('tablet') ||
            platform.is('desktop')
          "
          fill="clear">
          <div>
            <ion-icon name="call" size="large"></ion-icon>
            <br />
            <ion-label>Appeler</ion-label>
          </div>
        </ion-button>
      </ion-col>
      <ion-col size="4">
        <ion-button
          fill="clear"
          (click)="openInfosPdv()"
          (keydown)="openInfosPdv()">
          <div class="w-100">
            <ion-icon name="information-circle" size="large"></ion-icon>
            <br />
            <ion-label>Infos PDV</ion-label>
          </div>
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row class="ion-text-center">
      <ion-col size="4">
        <ion-button
          (click)="openSurvey()"
          (keydown)="openSurvey()"
          fill="clear">
          <div>
            <ion-img
              src="assets/icon/survey.png"
              style="height: 30px"></ion-img>
            <br />
            <ion-label>Survey</ion-label>
          </div>
        </ion-button>
      </ion-col>
      <ion-col size="4">
        <ion-button
          (click)="openMail()"
          (keydown)="openMail()"
          [disabled]="!pdv.email"
          fill="clear">
          <div class="w-100">
            <ion-icon name="mail" size="large"></ion-icon>
            <br />
            <ion-label>Envoyer e-mail</ion-label>
          </div>
        </ion-button>
      </ion-col>
      <ion-col size="4"></ion-col>
    </ion-row>
    <ion-row class="ion-text-center close-button">
      <ion-col size="12">
        <ion-button
          (click)="close()"
          (keydown)="close()"
          color="dark"
          fill="solid">
          Fermer
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
  }
</ion-content>
